import type { DocumentNode } from 'graphql';

/**
 * Get the operation name from a GraphQL mutation or query
 * @param gqlMutation - GQL mutation or query
 * @returns operation name or null if not found
 */
export const getGqlOperationName = (gqlMutation: DocumentNode): string | null => {
  // gqlMutation.definitions is an array, so we find the first definition
  // of type 'OperationDefinition' which represents our mutation or query
  const operationDefinition = gqlMutation?.definitions?.find(
    (definition) => definition?.kind === 'OperationDefinition'
  );

  // Return the operation name or null if not found
  return operationDefinition?.name?.value || null;
};

/**
 * Get the first fragment name from a GraphQL fragment
 * @param gqlFragment - GQL fragment
 * @returns fragment name or null if not found
 */
export const getGqlFragmentName = (gqlFragment: DocumentNode): string | null => {
  // gqlFragment.definitions is an array, so we find the first definition
  // of type 'FragmentDefinition' which represents the first (which is what we need) fragment
  const operationDefinition = gqlFragment?.definitions?.find(
    (definition) => definition?.kind === 'FragmentDefinition'
  );

  // Return the fragment name or null if not found
  return operationDefinition?.name?.value || null;
};
